var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 0H0.833333C0.373333 0 0 0.373333 0 0.833333V4.16667C0 4.62667 0.373333 5 0.833333 5H4.16667C4.62667 5 5 4.62667 5 4.16667V0.833333C5 0.373333 4.62667 0 4.16667 0Z",
    fill: "#F66524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 0H9C8.448 0 8 0.373333 8 0.833333V4.16667C8 4.62667 8.448 5 9 5H23C23.552 5 24 4.62667 24 4.16667V0.833333C24 0.373333 23.552 0 23 0Z",
    fill: "#F66524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 7.5H0.833333C0.373333 7.5 0 7.87333 0 8.33333V11.6667C0 12.1267 0.373333 12.5 0.833333 12.5H4.16667C4.62667 12.5 5 12.1267 5 11.6667V8.33333C5 7.87333 4.62667 7.5 4.16667 7.5Z",
    fill: "#F66524"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.5H9C8.448 7.5 8 7.87333 8 8.33333V11.6667C8 12.1267 8.448 12.5 9 12.5H23C23.552 12.5 24 12.1267 24 11.6667V8.33333C24 7.87333 23.552 7.5 23 7.5Z",
    fill: "#F66524"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15H0.833333C0.373333 15 0 15.3733 0 15.8333V19.1667C0 19.6267 0.373333 20 0.833333 20H4.16667C4.62667 20 5 19.6267 5 19.1667V15.8333C5 15.3733 4.62667 15 4.16667 15Z",
    fill: "#F66524"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15H9C8.448 15 8 15.3733 8 15.8333V19.1667C8 19.6267 8.448 20 9 20H23C23.552 20 24 19.6267 24 19.1667V15.8333C24 15.3733 23.552 15 23 15Z",
    fill: "#F66524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatistics);
export default __webpack_public_path__ + "static/media/IconStatistics.703c616f16525d5e6b2de0ad9a07716d.svg";
export { ForwardRef as ReactComponent };